import type { BatteryStatus } from '@connectdevice/types';

export type OperationalStatus =
  | BatteryStatus
  | 'APPROVED'
  | 'FAILED'
  | 'RETEST'
  | 'RECHARGE'
  | 'OFFLINE'
  | 'IDLE'
  | 'ONLINE'
  | 'ANALYZING';

export interface StatusToken {
  label: string;
  dotClass: string;
  textClass: string;
  badgeClass: string;
  barClass: string;
}

export const statusTokens: Record<OperationalStatus, StatusToken> = {
  GOOD: {
    label: 'GOOD',
    dotClass: 'bg-console-good',
    textClass: 'text-console-good',
    badgeClass: 'border-console-good/30 bg-console-good/15 text-console-good',
    barClass: 'bg-console-good',
  },
  APPROVED: {
    label: 'APPROVED',
    dotClass: 'bg-console-good',
    textClass: 'text-console-good',
    badgeClass: 'border-console-good/30 bg-console-good/15 text-console-good',
    barClass: 'bg-console-good',
  },
  HALF: {
    label: 'HALF',
    dotClass: 'bg-console-half',
    textClass: 'text-console-half',
    badgeClass: 'border-console-half/30 bg-console-half/15 text-console-half',
    barClass: 'bg-console-half',
  },
  RETEST: {
    label: 'RETEST',
    dotClass: 'bg-console-half',
    textClass: 'text-console-half',
    badgeClass: 'border-console-half/30 bg-console-half/15 text-console-half',
    barClass: 'bg-console-half',
  },
  RECHARGE: {
    label: 'RECHARGE',
    dotClass: 'bg-console-half',
    textClass: 'text-console-half',
    badgeClass: 'border-console-half/30 bg-console-half/15 text-console-half',
    barClass: 'bg-console-half',
  },
  RECARGA: {
    label: 'RECARGA',
    dotClass: 'bg-console-blueSoft',
    textClass: 'text-console-blueSoft',
    badgeClass: 'border-console-blueSoft/30 bg-console-blueSoft/15 text-console-blueSoft',
    barClass: 'bg-console-blueSoft',
  },
  DEFECT: {
    label: 'DEFECT',
    dotClass: 'bg-console-defect',
    textClass: 'text-console-defect',
    badgeClass: 'border-console-defect/30 bg-console-defect/15 text-console-defect',
    barClass: 'bg-console-defect',
  },
  FAILED: {
    label: 'FAILED',
    dotClass: 'bg-console-defect',
    textClass: 'text-console-defect',
    badgeClass: 'border-console-defect/30 bg-console-defect/15 text-console-defect',
    barClass: 'bg-console-defect',
  },
  OFFLINE: {
    label: 'OFFLINE',
    dotClass: 'bg-console-offline',
    textClass: 'text-console-muted',
    badgeClass: 'border-console-line bg-console-panelHigh text-console-muted',
    barClass: 'bg-console-offline',
  },
  IDLE: {
    label: 'IDLE',
    dotClass: 'bg-console-muted',
    textClass: 'text-console-muted',
    badgeClass: 'border-console-line bg-console-panelHigh text-console-muted',
    barClass: 'bg-console-muted',
  },
  ONLINE: {
    label: 'ONLINE',
    dotClass: 'bg-console-good',
    textClass: 'text-console-good',
    badgeClass: 'border-console-good/30 bg-console-good/15 text-console-good',
    barClass: 'bg-console-good',
  },
  ANALYZING: {
    label: 'ANALYZING',
    dotClass: 'bg-console-blueSoft',
    textClass: 'text-console-blueSoft',
    badgeClass: 'border-console-blueSoft/30 bg-console-blueSoft/15 text-console-blueSoft',
    barClass: 'bg-console-blueSoft',
  },
};

export function getStatusToken(status: OperationalStatus): StatusToken {
  return statusTokens[status] ?? statusTokens.IDLE;
}
